const idApuracaoIndicador = "idenApuracaoIndicador";
export const FormIdentificacaoPrograma = {
  descricaoItem: "",
  codFiplanItem: "",
  descPublicoAlvo: "",
  responsavel: "",
  programa: {
    codgPrograma: "",
    flagTipoPrograma: "",
    diretriz: {
      nomeDiretriz: "",
      eixo: { nomeEixo: "" },
    },
    objetivos: [{ codgObjetivo: "", nomeObjetivo: "" }],
  },
  unidadeOrcamentaria: {
    descricaoFiplan: "",
    descUo: "",
  },
};

export const FormIdentificacaoAcao = {
  idenPtaMonitora: null,
  ptaFiplan: {
    descElemento: "",
    descricaoFiplan: "",
    ptaFiplanDetalhe: {
      descObjetivo: "",
      descPublicoAlvo: "",
    },
    objetivos: [{ codgObjetivo: "", nomeObjetivo: "" }],
  },
  pessoaResp: {
    nomePessoa: "",
  },
  produtoAcao: [
    {
      ptaFiplan: {
        descElemento: "",
        unidadeMedida: {
          descUnidadeMedida: "",
        },
      },
      produtoAcaoRegiao: [
        {
          valrMetaOriginal: null,
          valrMetaAtualizada: null,
          valrRealizado: null,
        },
      ],
    },
  ],
};

export function buscarItemPrograma(idView) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/itemprogramarags/dados/PROGRAMA/" + idView).then((res) => {
      resolve(res);
    });
  });
}

export function buscarItemAcao(idView) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/acaorags/dados/" + idView).then((res) => {
      resolve(res);
    });
  });
}

export function buscarItemAcao2024(idenProduto, idenPtaMonitora) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/acaorags/dados2024/" + idenProduto + "/" + idenPtaMonitora).then((res) => {
      resolve(res);
    });
  });
}

export function buscarOdsFiplan(idenPtaFiplan) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/ptafiplans/" + idenPtaFiplan + "/ods").then((res) => {
      resolve(res);
    });
  });
}

export function buscarPercentualAcao(idenExercicio, tipoItem, idenPtaMonitora) {
  return new Promise(async (resolve, reject) => {
    window.$http
      .get("/respostaitemquestacaos/percentualacao/" + idenExercicio + "/" + tipoItem + "/" + idenPtaMonitora)
      .then((res) => {
        resolve(res);
      });
  });
}

export function buscarApuracaoIndicadores(idenPPA, codgPrograma) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/apuracaoindicadors/buscarPorCodgPrograma/" + idenPPA + "/" + codgPrograma).then((res) => {
      resolve(res);
    });
  });
}

export function buscarApuracaoByIndenIndicador(idenIndicador) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/apuracaoindicadors/buscarPorIdenIndicador/" + idenIndicador).then((res) => {
      res.data = res.data !== "" ? res.data : null;
      let vlrApurado = res.data !== null ? res.data.vlrApurado : null;
      if (vlrApurado !== null) {
        res.data.valorApuradoFormatado = new Number(res.data.valrApurado).toLocaleString("pt-BR", {
          minimumFractionDigits: 3,
        });
      }
      resolve(res);
    });
  });
}

export function buscaAnaliseAcaoIndicadorByidenPtaMonitoraByidenPtaFiplanIndicador(
  idenPtaMonitora,
  idenPtaFiplanIndicador
) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`/v1/analise/acao/indicadors/${idenPtaMonitora}/${idenPtaFiplanIndicador} `).then((res) => {
      res.data = res.data !== "" ? res.data : null;
      let vlrApurado = res.data !== null ? res.data.vlrApurado : null;
      if (vlrApurado !== null) {
        res.data.valorApuradoFormatado = new Number(res.data.valrApurado).toLocaleString("pt-BR", {
          minimumFractionDigits: 3,
        });
      }
      resolve(res);
    });
  });
}

export function buscarMetaPPA(idenObjetivo, idenIndicador, idenPrograma) {
  return new Promise(async (resolve, reject) => {
    window.$http
      .get("/apuracaoindicadors/metaPPA/" + idenObjetivo + "/" + idenIndicador + "/" + idenPrograma)
      .then((res) => {
        resolve(res);
      });
  });
}

export function buscarQuestionarioIndicador(idenIndicador) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/itemindicadorrags/dados/" + idenIndicador).then((res) => {
      resolve(res);
    });
  });
}

export function salvarAvaliacaoPrograma(codigoItem, campos) {
  return new Promise((resolve, reject) => {
    window.$http.put(`/itemprogramarags/avaliacoes/${codigoItem}`, JSON.stringify(campos)).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvarAvaliacaoIndicador(idenIndicador, campos) {
  return new Promise((resolve, reject) => {
    window.$http.put(`/itemindicadorrags/avaliacoes/${idenIndicador}`, JSON.stringify(campos)).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvarApuracaoIndicador(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[idApuracaoIndicador] && parm[idApuracaoIndicador] !== 0) {
      await atualizarApuracaoIndicador(parm).then((res) => {
        resolve(res);
      });
    } else {
      await criarApuracaoIndicador(parm).then((res) => {
        resolve(res);
      });
    }
  });
}

export function removerApuracaoIndicador(idenApuracaoIndicador) {
  return new Promise(async (resolve, reject) => {
    window.$http.delete(`apuracaoindicadors/${idenApuracaoIndicador}`).then((res) => {
      resolve(res);
    });
  });
}

export function atualizarApuracaoIndicador(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`apuracaoindicadors/${parm[idApuracaoIndicador]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criarApuracaoIndicador(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`apuracaoindicadors/`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarOdsPrograma(idFiplanPrograma) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/itemprogramarags/odsprograma/" + idFiplanPrograma).then((res) => {
      resolve(res);
    });
  });
}

export function buscarCalceiProgramaExec(idExercicio, idView) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`/analiseprogramas/cei/${idExercicio}/${idView}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscarPreenchimentoQuestoesInd(idenExercicio, tipoItem, listaIds) {
  return new Promise((resolve, reject) => {
    window.$http
      .post(`/questionarioitem/${idenExercicio}/${tipoItem}/listaIds`, JSON.stringify(listaIds))
      .then((res) => {
        resolve(res.data);
      });
  });
}

export function getRealizadoProgramaByPlan72RealizadoAcao(codgExercicio, codgUo, codgPrograma) {
  return new Promise((resolve, reject) => {
    window.$http.get(`/realizado-programa/${codgExercicio}/${codgUo}/${codgPrograma}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscarProrrogacaoPorPrograma(idenPrograma) {
  return new Promise((resolve, reject) => {
    window.$http.get(`/prorrogacaorags/buscarPorPrograma/${idenPrograma}`).then((res) => {
      resolve(res);
    });
  });
}



export function buscarProrrogacaoPorAcao(idenPtaFiplan) {
  return new Promise((resolve, reject) => {
    window.$http.get(`/prorrogacaorags/buscarPorAcao/${idenPtaFiplan}`).then((res) => {
      resolve(res);
    });
  });
}
